import { IsNotEmpty, IsOptional } from "class-validator";

export class EditRunningOrderJudgeDto {
  @IsNotEmpty()
  old_judge_name: string;

  @IsOptional()
  old_judge_number?: string;

  @IsNotEmpty()
  judge_name: string;

  @IsOptional()
  judge_number?: string;
}
